module.exports = __webpack_public_path__ + "img/canvas-morning-cool.0f87bf4e.jpg";